import * as styleHelpers from "@affinity/constants/StyleHelpers";
import styled, { css } from "styled-components";

export const colours = {
    lightGreen: "#89BD2E",
    lightGreen50: "#C4DE96",
    lightGreen20: "#E7F2D5",
    green: "#12703C",
    midGreen: "#43893D",
    darkBlue: "#125252",
    darkBlue60: "#719797",
    lightBlue: "#A6D4CF",
    lightBlue50: "#D2E9E7",
    lightBlue20: "#EDF6F5",
    white: "#FFFFFF",
    darkGrey: "#4D4D4D",
    black: "#000000",
    errorRed: "#E00000",
};
export const fontFamilyImportUrl = "https://use.typekit.net/gpf1rbj.css"; // TODO: Replace with production URL
export const bodyFont = '"museo-sans",sans-serif';
export const headerFont = '"bookmania",serif';
export const headerMargins = css`
    margin-bottom: -0.43em;
    margin-top: -0.07em;
`;

export const defaultCSS = {
    tag: css`
        padding: ${styleHelpers.rem(12)} ${styleHelpers.rem(10)} ${styleHelpers.rem(12)} ${styleHelpers.rem(10)};
        border-radius: 0;
        align-items: center;
        button {
            min-height: ${styleHelpers.rem(20)};
            border-radius: 0;
            padding: 0;
            margin: 0;
        }
    `,
    menuLinkNormal: css`
        color: ${colours.white};
        :hover,
        a:hover,
        button:hover {
            color: ${colours.lightBlue};
            svg,
            span svg,
            nav span span {
                color: ${colours.lightBlue};
            }
        }
    `,
    menuLinkForce: css`
        color: ${colours.white};
        :hover,
        a:hover,
        button:hover,
        :focus-within {
            color: ${colours.lightBlue}!important;
            text-decoration: underline;
            svg,
            span svg,
            span,
            span span {
                color: ${colours.lightBlue};
            }
        }
    `,
    menuLinkNav: css`
        border-bottom: 1px solid ${colours.lightBlue};
        a span {
            color: ${colours.darkBlue};
        }
        a:hover {
            background-color: ${colours.white};
            span {
                color: ${colours.darkBlue};
                text-decoration: underline;
            }
        }
    `,
    menuLinkAcc: css`
        border-bottom: 1px solid ${colours.lightBlue};
        a span {
            color: ${colours.darkBlue};
        }
        a:hover {
            background-color: ${colours.lightBlue};
            span {
                color: ${colours.black};
                text-decoration: underline;
            }
        }
    `,
    menuPolygon: css``,
};
/**
 * Styles the ButtonLink component as plain text with icon
 */
export const textIconButton = css`
    background-color: transparent;
    border: 0;
    color: ${colours.darkBlue};
    gap: 5px;
    padding:0;
    text-decoration: underline;
    &:focus-visible, &:hover{
        border:0;
    }
    &:not(:disabled){
        &:focus-visible, &:hover{
            text-decoration: none;
        }
    }
    &:disabled{
        opacity: 0.7;
        border:0 !important;
        background-color: transparent !important;
        text-decoration: underline;
    }
    @media (min-width: ${styleHelpers.rem(768)}){
        gap: 10px;
    }
`;

/**
 * Stack content in reverse and then align at end on larger screens
 */
export const FlexWrapEnd = styled.div`
    position: relative;
    width: 100%;
    height:auto;
    display:flex;
    flex-flow: column-reverse;
    justify-content: flex-end;
    align-content: flex-end;
    justify-content: flex-end;
    gap: 15px;
    @media (min-width: ${styleHelpers.breakpointWidth("md")}) {
        flex-flow: row;
        gap: 40px;
    }
    *{
        flex: 0 1 auto;
        margin: 0 0 0 auto;
        @media (min-width: ${styleHelpers.breakpointWidth("md")}) {
            margin:0;
        }
    }
`;